import React from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { color } from '@styles/themes';
import { Row as ARow, RowProps } from 'antd';
import { tuple } from 'antd/lib/_util/type';

export const tYzTypeRow = tuple(
  'vertical',
  'additionalGroup',
  'additionalRow',
  'additionalRowInOneField',
  'header',
  'footer-single-button',
  'footer-double-button',
  'term-bottom-1',
  'term-bottom-2',
  'center',
);

export type TYzTypeRow = (typeof tYzTypeRow)[number] | undefined;

export interface IRowParams extends RowProps {
  yzTypeRow?: TYzTypeRow;
  align?: RowProps['align'] & 'center';
}

const handleRowStyleWithType = ({ yzTypeRow }: IRowParams) => {
  switch (yzTypeRow) {
    case 'header':
      return css`
        height: 63px;
        width: 100%;
      `;
    case 'footer-single-button':
      return css`
        display: flex;
        column-gap: 7px;
        flex-wrap: no-wrap;
        width: 100%;
        height: 68px;
        padding: 8px 0;
        position: sticky;
        bottom: 0px;
        background: #ffffff !important;
        z-index: 999;
      `;
    case 'footer-double-button':
      return css`
        display: flex;
        width: 100%;
        align-content: space-between;
        height: 122px;
        padding-bottom: 12px;
        position: sticky;
        bottom: 0;
        z-index: 999;
      `;
    case 'term-bottom-1':
      return css`
        height: 16px;
        width: 100%;
        display: flex !important;
        z-index: 999;
        justify-content: space-between;
        align-items: center;
      `;
    case 'term-bottom-2':
      return css`
        height: 16px;
        width: 100%;
        display: flex !important;
        z-index: 999;
        justify-content: space-between;
        align-items: center;
      `;
    case 'center':
      return css`
        margin: 0 auto !important;
      `;
    case 'vertical':
      return css`
        display: block;
      `;
    case 'additionalGroup':
      return css`
        margin-top: 20px !important;
        margin-bottom: 30px !important;
        padding-top: 21px !important;
        padding-bottom: 20px !important;
        border-top: 1px solid #8991a3;
        border-bottom: 1px solid #8991a3;
        background: rgba(142, 172, 255, 0.07);
      `;
    case 'additionalRow':
      return css`
        margin-top: 20px;
      `;
    case 'additionalRowInOneField':
      return css`
        margin-top: 5px;
      `;
    default:
      return css`
        &::before {
          content: none;
        }

        &::after {
          content: none;
        }
      `;
  }
};

const isPropValid = (props: any) => props !== 'yzTypeRow';

const StyledRow = styled(ARow, { shouldForwardProp: isPropValid })<IRowParams>`
  ${({ yzTypeRow }) => handleRowStyleWithType({ yzTypeRow })}
`;

export const Row = ({ children, ...rest }: IRowParams) => <StyledRow {...rest}>{children}</StyledRow>;
